import {
	get as amplifyGet,
	post as amplifyPost,
	put as amplifyPut,
	del as amplifyDelete,
} from "@aws-amplify/api-rest";
import { fetchAuthSession } from "aws-amplify/auth";

export const myInitHeader = async () => {
	const session = await fetchAuthSession();

	return {
		headers: {
			Authorization: `Bearer ${session.tokens.idToken.toString()}`,
		},
	};
};

// GET
export async function get(path, name) {
	let apiName = name;

	const myNewInit = await myInitHeader();

	try {
		const operation = amplifyGet({
			apiName,
			path,
			options: {
				headers: myNewInit.headers,
			},
		});

		const response = await operation.response;

		return response.body.json();
	} catch (e) {
		throw getValidErrors(e, path);
	}
}

export async function post(
	path,
	name,
	data,
	customresHeader = {},
	customreqHeader = {},
) {
	let apiName = name;

	const myNewInit = await myInitHeader();

	try {
		const operation = amplifyPost({
			apiName,
			path,
			options: {
				body: data,
				headers: { ...myNewInit.headers, ...customreqHeader },
				...customresHeader,
			},
		});

		const { body } = await operation.response;

		const response = await body.json();

		return response;
	} catch (e) {
		throw getValidErrors(e, path);
	}
}

// DELETE
export const del = async (path, name, data) => {
	const responseObj = {};

	let apiName = name;

	const myNewInit = await myInitHeader();

	try {
		const operation = amplifyDelete({
			apiName,
			path,
			options: {
				body: data,
				headers: myNewInit.headers,
			},
		});

		const response = await operation.response;

		const result = await response.body.json();

		responseObj.posted = result.success;
		responseObj.success = result.success;
		responseObj.message = result.message;
		responseObj.data = result.data;

		return responseObj;
	} catch (e) {
		throw getValidErrors(e, path);
	}
};

// PUT
export const apiPut = async (path, name, data) => {
	const responseObj = {};

	let apiName = name;

	const myNewInit = await myInitHeader();

	try {
		const operation = amplifyPut({
			apiName,
			path,
			options: {
				body: data,
				headers: myNewInit.headers,
			},
		});

		const response = await operation.response;

		const result = await response.body.json();

		responseObj.code = "success";
		responseObj.message = result.message;
		responseObj.posted = result.success;
		responseObj.success = result.success;
		responseObj.data = result.data;

		return responseObj;
	} catch (e) {
		throw getValidErrors(e, path);
	}
};

const getValidErrors = (error, apiUrl) => {
	const errorDetails = error.response;

	if (errorDetails) {
		const {
			message,
			error: statusText,
			success,
			detailedMessages,
			data,
		} = errorDetails.data || {};

		const { status } = errorDetails;

		if (status === 401 || status === 403) {
			window.location.href =
				"/print/unauthorised?status=UnauthorisedStatusFromAPI";
		}

		if (status === 404) {
			window.location.href =
				"/print/PageNotFound?status=PageNotFoundfromAPI";
		}

		if (status >= 500) {
			window.location.href =
				"/print/error?status=InternalServerErrorFromAPI";
		}

		return { success, statusText, status, message, detailedMessages, data };
	}

	return {
		error: true,
		success: false,
		statusText: `${error.response} ${apiUrl}`,
		status: 500,
		message: "server is temporarily down.",
	};
};
